export default `float deee(vec3 p){
    vec3 R=p,Q;
    float d = 1.;
    Q=fract(R)-.5,
    X(Q.xy)
    X(Q.yz)
    X(Q.zx)
    d=max(d,.68-length(fract(R-.5)-.5));
    return d;
  }`